"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Project(props) {
    return (react_1.default.createElement("div", { className: 'bg-color-background-default container rounded-2xl' },
        react_1.default.createElement("div", { className: 'bg-gray-300 mx-3 my-3 m-auto rounded-xl' },
            react_1.default.createElement("div", { className: "container flex flex-wrap" },
                react_1.default.createElement("p", { style: { fontSize: 50 }, className: ' text-white bg-color-background-default container text-center' },
                    "#",
                    props.rank + 1),
                react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.project.title }, className: 'pb-6 justify-center my-auto container text-center content-center text-3xl text-white bg-color-background-default' })),
            react_1.default.createElement("iframe", { className: 'w-full aspect-square', src: 'https://www.youtube.com/embed/' + props.project.youtube, title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture', allowFullScreen: true }),
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.project.body }, className: 'bg-gray-300 text-center p-4' }))));
}
exports.default = Project;
